import { Box, useTheme } from "@mui/material";
import lightLogo from "../../assets/logos/light/wellenzahl-logo-light.svg";
import darkLogo from "../../assets/logos/dark/wellenzahl-logo-dark.svg";


function AppLogoSpinning() {
    const theme = useTheme()

    return (
        <Box display="flex" justifyContent="center" alignItems="center">
            {theme.palette.mode === "dark" ? (
                <img src={lightLogo} className="app-logo-spinning" alt="logo" />
            ) : (
                <img src={darkLogo} className="app-logo-spinning" alt="logo" />
            )}
        </Box>
    );
}

export default AppLogoSpinning;
